import React, { useState } from 'react'
export const CurrentProjectManagerContext = React.createContext({})

export default function CurrentProjectManagerProvider(props) {
  const [currentProjectManager, setCurrentProjectManager] = useState({})

  return (
    <CurrentProjectManagerContext.Provider value={{ currentProjectManager, setCurrentProjectManager }}>
      {props.children}
    </CurrentProjectManagerContext.Provider>
  )
}
